import React from 'react'
import './override.css'
import Svg from './Svg'

const ConceptName = ({ name }) => {
  if (/riu/gi.test(name)) return null

  switch (name) {
    case 'Suneo Club':
      return (
        <span className="text">
          <strong>Suneo</strong>Club
        </span>
      )
    case 'Blue Star':
      return (
        <span className="text">
          <strong>Blue</strong>Star
        </span>
      )
    case 'TUI Blue For Families':
    case 'TUI Blue For Two':
    case 'TUI Blue For All':
      return <span className="text">TUI Blue</span>
    default:
      return <span className="text">{name}</span>
  }
}

export default ({ concept, hotel }) => {
  const conceptClass = concept && concept.slug
  if (!conceptClass) return null
  const isVillage = ['P-000008344', 'P-000008936'].some((i) => i === hotel)
  return (
    <div className={`tui-concept-logo ${conceptClass} ${isVillage ? 'is-village' : ''}`}>
      {conceptClass !== 'tuisensatori' && <Svg concept icon={conceptClass} />}
      <ConceptName name={concept.name === 'TUI Blue Sensatori' ? 'Sensatori' : concept.name} />
    </div>
  )
}
